import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorCodeEntryConfirmReactionListColumnsEnum } from '../behavior-code-entry-confirm-reaction-models/behavior-code-entry-confirm-reaction-list-columns.enum';
import {
  AnalyticsEventEnum,
  DateUtil,
  PrivilegeEnum
} from '@whetstoneeducation/hero-common';
import { BaseTableComponent } from '../../../../shared/tables/base-table/base-table';
import { AppToastManagerService } from '../../../../shared/services/toast-manager.service';
import { PrinterService } from '../../../../shared/printer/printer.service';
import { AppPrivilegesService } from '../../../auth/privileges.service';
import { printPass } from '../../../../shared/printer/browser-print.util';
import { AppAnalyticsService } from '../../../../shared/services/analytics.service';
import { AppBehaviorCodeEntryService } from '../../behavior-code-entry.service';
import type { PrintableReactionEntry } from '../behavior-code-entry-confirm-reactions.component';

@Component({
  selector: 'app-behavior-code-entry-confirm-reaction-table',
  templateUrl: './behavior-code-entry-confirm-reaction-table.component.html',
  styleUrls: ['./behavior-code-entry-confirm-reaction-table.component.scss']
})
export class BehaviorCodeEntryConfirmReactionTableComponent extends BaseTableComponent<PrintableReactionEntry> {
  @Input() reloadTable: () => Promise<void>;
  @Input() browserPrint: boolean;
  @Output() editReaction = new EventEmitter<PrintableReactionEntry>();
  protected hasNecessaryPrivilegeToEdit: boolean;

  public get displayedColumns() {
    return Object.values(BehaviorCodeEntryConfirmReactionListColumnsEnum);
  }

  public columnValues = {
    [BehaviorCodeEntryConfirmReactionListColumnsEnum.STUDENT_NAME]: [
      'Student Name'
    ],
    [BehaviorCodeEntryConfirmReactionListColumnsEnum.REACTION]: ['Reaction'],
    [BehaviorCodeEntryConfirmReactionListColumnsEnum.REACTION_DATE]: [
      'Reaction Date'
    ],
    [BehaviorCodeEntryConfirmReactionListColumnsEnum.ACTIONS]: ['Actions']
  };

  public columns = BehaviorCodeEntryConfirmReactionListColumnsEnum;
  public showPrintReactionButton: boolean = false;

  constructor(
    public toastManager: AppToastManagerService,
    public behaviorCodeEntryService: AppBehaviorCodeEntryService,
    privilegesService: AppPrivilegesService,
    private printer: PrinterService,
    private analyticsService: AppAnalyticsService,
  ) {
    super({ privilegesService });

    this.hasNecessaryPrivilegeToEdit =
      this.privilegeService.hasPrivilege(PrivilegeEnum.MANAGE_BEHAVIOR_CODE) ||
      this.privilegeService.hasPrivilege(PrivilegeEnum.EDIT_BEHAVIOR_CODE_CONSEQUENCES)
    ;

    this.printer.updater = () => {
      this.showPrintReactionButton = true;
    };
  }

  public async onEditReaction(
    reaction: PrintableReactionEntry
  ): Promise<void> {
    this.editReaction.emit(reaction);
  }

  public async onPrintReaction(reaction: PrintableReactionEntry): Promise<void> {
    if (this.printer.usbAvailable) {
      try {
        const printTrack = await this.behaviorCodeEntryService.generatePrintData(
          this.printer.configuration.languageType,
          reaction
        );

        for (let i = 0; i < reaction.printCopies; i++) {
          this.printer.addToPrintQueue(printTrack);
        }

      } catch (error) {
        this.toastManager.error('Error printing reaction, printer not found');
      }

    } else if (!this.printer.usbAllowed || this.browserPrint) {
      // If the browser print is allowed, then print the pass in the browser
      printPass(reaction);
      this.analyticsService.track(
        AnalyticsEventEnum.PASS_PRINTED,
        reaction.id
      );
    }
  }

  DateUtil = DateUtil;
  PrivilegeEnumbroke = PrivilegeEnum;
}
